import { render, staticRenderFns } from "./StudentDocumentsHistory.vue?vue&type=template&id=08a5c8fb&"
import script from "./StudentDocumentsHistory.vue?vue&type=script&lang=ts&"
export * from "./StudentDocumentsHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports